<template>
  <div class="fin-side-navigation-mobile">
    <!-- opened navigation drawer -->
    <v-navigation-drawer v-if="$vuetify.breakpoint.xsOnly"
                         width="100%"
                         height="100%"
                         app
                         dark
                         temporary
                         touchless
                         fixed
                         v-model="drawer"
                         class="fin-side-navigation-drawer fin-color-primary-dark">

      <div class="logo-block">
        <v-btn :to="{name: 'myFinHub'}" @click="closeNavigation" class="fin-icon-full">
          <fin-logo-full border/>
        </v-btn>

        <v-btn class="fin-icon-close" icon @click.stop="drawer = !drawer">
          <v-icon style="font-size: 20px">icon-close</v-icon>
        </v-btn>
      </div>

      <!-- Navigation -->
      <fin-scrollable-list class="nav-content fin-color-primary-dark"
                           style="padding-top: 86px;">
        <!-- Main-Navigation -->
        <v-list-item :class="`${item.class} px-0 ${item.id}`"
                     :key="item.name"
                     :link="!item.disabled"
                     @click="!item.disabled ? goToLink(item.to,index) : null"
                     v-for="(item,index) in routes"
        >
          <v-list-item-content class="nav-link">
            <v-icon :class="item.disabled ? 'nav-icon color-disabled' : 'nav-icon color-enabled'">{{
                item.icon
              }}
            </v-icon>
            <v-list-item-title :class="item.disabled ? 'link-text color-disabled' : 'link-text color-enabled'">
              {{ item.name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </fin-scrollable-list>

      <!-- Footer-Navigation -->
      <template #append>
        <v-container class="profile-signOut d-flex pa-0">
          <v-row class="signOutRow">
            <v-col class="signOutCol pa-1" style="max-width: 80px">
              <v-btn class="transparentBtn" light :to="{name: 'myProfile'}" @click="closeNavigation">
                <v-avatar>
                  <fin-profile-img/>
                </v-avatar>
              </v-btn>
            </v-col>
            <v-col class="signOutCol signOutName pa-1" style=" width: 0;">
              <div class="btnContainer" style="height: 100%">
                <v-btn class="transparentBtn pa-0" light style="width: 100%; min-width: 0; text-align: start;"
                       :to="{name: 'myProfile'}" @click="closeNavigation">
                  <fin-current-user-name :style="'color:' + $finColors.primaryDark"/>
                </v-btn>
              </div>
            </v-col>
            <v-col class="signOutCol pa-1" style="max-width: 80px;">
              <v-divider dark
                         inset
                         style="padding: 0 5px; height: 44px;" vertical/>
              <fin-sign-out-btn icon style="padding: 0 19px 0 11px;"/>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-navigation-drawer>

    <!-- bottom navigation -->
    <v-bottom-navigation v-if="!drawer"
                         app
                         ref="finSideBottomNavigation"
                         class="fin-side-bottom-navigation">
      <fin-bottom-navigation-button :click="myFinHubClicked"
                                    icon="icon-dashboard"
                                    helpcenter-class="main-menuitem-finHub"
                                    label="Dashboard"/>

      <fin-bottom-navigation-button icon="icon-search"
                                    label="Suche"
                                    helpcenter-class="main-menuitem-search"
                                    :click="searchBarClicked"/>
      <v-menu top
              offset-y
              v-model="showPopupVal"
              :close-on-content-click="false"
              :close-on-click="false"
              class="elevation-0"
              content-class="elevation-0 fin-help-center-tooltip mobile-nudge"
              eager
              z-index="51"
              :max-width="350">
        <template #activator="{ on }">
          <fin-bottom-navigation-button :click="openHelpCenter"
                                        :disabled="!hasContextHelp"
                                        icon="icon-academy"
                                        label="Hilfezentrum"/>
          <!-- Empty div to bind activator to nothing-->
          <div v-on="on"/>
        </template>

        <div class="fin-tooltip-help-center">
          <v-col class="px-4">
            <v-btn @click="closePopup"
                   class="fin-icon-close"
                   icon>
              <v-icon size="16px">icon-close</v-icon>
            </v-btn>

            <div class="tooltip-title py-2">Hilfezentrum</div>
            <div class="tooltip-text">
              Hier findest du weitere Hilfestellungen in Form von geführten Touren, Videos oder Erklärungen.
            </div>
            <div class="d-flex justify-end mt-2">
              <v-btn @click="openHelpCenter">
                Öffnen
              </v-btn>
            </div>
          </v-col>
        </div>
      </v-menu>

      <fin-bottom-navigation-button :click="openLexicon"
                                    icon="icon-lexicon"
                                    helpcenter-class="main-menuitem-lexicon"
                                    label="finLexikon"/>
    </v-bottom-navigation>

  </div>
</template>

<script>
import FinLogoFull from '@/components/common/logo/LogoFull/index'
import FinProfileImg from '@/components/pages/profile/ProfileImg'
import FinSignOutBtn from '@/components/auth/SignOutBtn'
import FinCurrentUserName from '@/components/auth/CurrentUserName/index'
import FinBottomNavigationButton
  from '@/components/navigation/sideNavigation/sideNavigationMobile/BottomNavigationButton'
import {EventBus} from "@/plugins/fincraft"
import {finSpeakerAPI} from "@/js/finAPI"
import {mapGetters, mapState} from "vuex"
import {speakerMessageSubscription} from "@/js/finSubscriptions"
import SubscriptionHandler from "@/mixins/SubscriptionHandler"
import AmplitudePush from "@/mixins/AmplitudePush"

export default {
  name: 'FinSideNavigationMobile',
  components: {
    FinBottomNavigationButton,
    FinCurrentUserName,
    FinSignOutBtn,
    FinProfileImg,
    FinLogoFull
  },
  mixins: [SubscriptionHandler, AmplitudePush],
  props: {
    routes: {
      type: Array
    },
    hasContextHelp: {
      type: Boolean
    },
    showPopup: {
      type: Boolean
    }
  },
  data() {
    return {
      drawer: false,
      speakerMessages: [],
      speakerNextToken: null,
      subscriptionDone: false,
      // FINDEV-3575
      showPopupVal: false // this.showPopup
    }
  },
  computed: {
    ...mapGetters('auth', ['userId']),
    ...mapState({
      profile: state => state.auth.profile
    }),
    localStorageId() {
      return `helpCenter_popup_${this.profile.id}`
    }
  },
  methods: {
    closePopup() {
      localStorage.setItem(this.localStorageId, 'true')
      this.showPopupVal = false
      this.$emit("closePopup")
    },
    closeNavigation() {
      this.drawer = false
    },
    toggle() {
      this.drawer = !this.drawer
    },
    openHelpCenter() {
      this.pushToAmplitude({
        'event': 'fincraft_bottommenu_helpcenter',
        'step': 'bottommenu-helpcenter',
        'placement': 'bottommenu',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
      this.closePopup()
      EventBus.$emit('showHelpCenter')
    },
    openLexicon() {
      this.pushToAmplitude({
        'event': 'fincraft_bottommenu_lexikon',
        'step': 'bottommenu_lexikon',
        'placement': 'bottommenu',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
      EventBus.$emit('showLexicon', null, false)
    },
    myFinHubClicked() {
      this.pushToAmplitude({
        'event': 'fincraft_bottommenu_finhub',
        'step': 'bottommenu_myhub',
        'placement': 'bottommenu',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
      this.$router.push({name: 'myFinHub'})
    },
    searchBarClicked() {
      this.pushToAmplitude({
        'event': 'fincraft_bottommenu_navi_autocomplete_search',
        'step': 'autocomplete_search',
        'placement': 'bottommenu',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
      EventBus.$emit('showMobileSearch', true)
    },
    goToLink(route, index) {
      if (index) {
        this.pushToAmplitude({
          'event': this.routes[index].event,
          'step': this.routes[index].step,
          'placement': this.routes[index].placement,
          'vue_breakpoint': this.$vuetify.breakpoint.name
        })
      }

      this.toggle()
      this.$router.push(route)
    },
    async getUnreadMessages(limit = 10) {
      try {
        const result = await finSpeakerAPI.getUnreadMessages(this.userId, limit, this.speakerNextToken)
        this.speakerNextToken = result.nextToken
        // always put it at the end of the list
        this.speakerMessages = [...this.speakerMessages, ...result.items]
      } catch (e) {
        console.error('speakerMessagesUnread failed', e)
      }

      if (!this.subscriptionDone) {
        this.subscribeToChanges(
          {id: this.userId},
          speakerMessageSubscription,
          (user) => {
            return {owner: user.id}
          },
          this.handleSubscription
        )
        this.subscriptionDone = true
      }
    },
    handleSubscription(newData, user) {
      const {id, createdAt, readAt, status, message} = newData.data.onSpeakerMessageRecipient

      // if readAt is set at subscription event => remove from unread list
      if (readAt) {
        this.speakerMessages = this.speakerMessages.filter(m => m.id !== id)

        // if there are more unread messages add them to the end of the list
        if (this.nextToken) {
          this.getUnreadMessages(1)
        }
      }
      // readAt not set => add to top of unread list
      else {
        this.speakerMessages.unshift({id, createdAt, readAt, status, message})
      }
    },
  },
  watch: {
    showPopup(newVal) {
      // FINDEV-3575
      this.showPopupVal = false//newVal
    }
  },
  async beforeMount() {
    await this.getUnreadMessages()
  },
}
</script>

<style lang="scss" scoped>
@import "../SideNavigation";

$fin-side-navigation-content-margin-left: 30px;

.fin-side-navigation-mobile {
  z-index: 200;

  .logo-block {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10;
    background-color: $fin-color-primary-dark;
  }

  .fin-side-navigation-bar {
    box-shadow: none !important;
  }

  .fin-side-bottom-navigation {
    display: flex;
    align-items: center;

    ::v-deep .v-btn {
      position: relative;
      height: 100%
    }

    ::v-deep .item-name {
      font-weight: normal;
      padding-top: 5px;
    }
  }

  .fin-side-navigation-drawer {

    ::v-deep .sign-out i {
      color: $fin-color-primary-dark !important;
    }

    .profile-signOut {
      height: 60px;
      margin-bottom: auto;

      .signOutRow {
        margin: 0;
        height: inherit;
      }

      .signOutCol {
        display: flex;
        align-items: center;
        background-color: $active-color;
      }

      .btnContainer {
        display: flex;
        flex-grow: 1;
        width: 0;
      }

      .transparentBtn {
        height: inherit;
        background-color: transparent !important;

        &::before {
          opacity: 0 !important;
        }
      }

      ::v-deep .v-btn__content {
        display: block;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        color: $fin-color-primary-dark !important;
        min-width: 0;
      }

      .username {
        font-weight: bold;
      }

      .theme--dark.v-divider {
        border-color: rgba(227, 227, 227, 1);
        height: 32px;
      }
    }
  }

  .fin-icon-full {
    margin: 25px 0 25px $fin-side-navigation-content-margin-left;
    padding: 0;

    .v-avatar {
      min-width: 120px !important;
      width: 120px !important;
    }
  }

  .fin-icon-close {
    float: right;
    margin: 10px;
  }

  .fin-icon, .fin-icon-full {
    &::before {
      background-color: transparent !important;
    }
  }

  .v-btn:not(.v-btn--round).v-size--default {
    box-shadow: none;
  }

  .v-list {
    padding-top: 0;

    .v-list-item {
      padding: 0;
      margin: 10px 0;

      /* display items horizontally in one line */
      .v-list-item__content {
        margin-left: $fin-side-navigation-content-margin-left;
        height: 60px;

        & > * {
          flex: unset !important;
        }

        .link-text {
          padding-left: 20px;
          font-size: 16px;
        }
      }
    }
  }

  .color-enabled,
  .nav-icon.color-enabled:before {
    color: #fff !important;
  }

  .color-disabled {
    color: rgba(255, 255, 255, 0.6) !important;
  }
}

</style>
